var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Settings24 = function Settings24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20.994 12a2.99 2.99 0 0 1 1.1-2.32 1.036 1.036 0 0 0 .37-1.08 11.022 11.022 0 0 0-2.309-3.98.977.977 0 0 0-1.09-.22 2.953 2.953 0 0 1-2.565-.2 3.018 3.018 0 0 1-1.459-2.13.981.981 0 0 0-.742-.83 11.15 11.15 0 0 0-4.6 0 .983.983 0 0 0-.74.83A3.017 3.017 0 0 1 7.5 4.2a2.955 2.955 0 0 1-2.569.2.977.977 0 0 0-1.09.22 11.018 11.018 0 0 0-2.3 3.98A1.033 1.033 0 0 0 1.9 9.68 2.987 2.987 0 0 1 3 12a2.988 2.988 0 0 1-1.1 2.32 1.035 1.035 0 0 0-.368 1.08 11 11 0 0 0 2.308 3.98.977.977 0 0 0 1.09.22 2.958 2.958 0 0 1 2.565.2 3.018 3.018 0 0 1 1.458 2.13.983.983 0 0 0 .74.83c1.517.32 3.083.32 4.6 0a.982.982 0 0 0 .74-.83 3.016 3.016 0 0 1 2.728-2.525c.445-.034.892.032 1.307.195a.977.977 0 0 0 1.09-.22 11.021 11.021 0 0 0 2.309-3.98 1.036 1.036 0 0 0-.37-1.08A2.99 2.99 0 0 1 20.994 12zm-9 2A2 2 0 1 1 12 14h-.006z",
    fill: "currentColor"
  }));
};

Settings24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Settings24
};
export var Settings = function Settings(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Settings' icon. Please use one of the available sizes: '24'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};